
import { motion } from "framer-motion";
import "../../asstes/styles/animationEffect.scss";

export default function AnimationEffect() {

    // Create one pentagon face (5 edges)
    const Face = () => (
        <div className="face">
            {Array.from({ length: 5 }).map((_, i) => (
                <div key={i} className="edge" />
            ))}
        </div>
    );

    // Create 12 faces
    const Dodecahedron = ({ className }) => (
        <div className={`dodecahedron ${className}`}>
            {Array.from({ length: 12 }).map((_, i) => (
                <Face key={i} />
            ))}
        </div>
    );

    return (
        <div className="scene">

            {/* LARGE */}
            <Dodecahedron className="layer-large" />

            {/* MEDIUM */}
            <Dodecahedron className="layer-medium" />

            {/* SMALL */}
            <Dodecahedron className="layer-small" />

        </div>
    );
} 